import React from "react";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material";

const Content = styled("span")(({ theme }) => ({
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  paddingRight: theme.spacing(1.3),
  paddingLeft: theme.spacing(1.3),
  fontSize: 16,
  textTransform: "uppercase",
  color: "black",
}));

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
    marginTop: "4%",
    marginBottom: "4%",
  },
  border: {
    borderBottom: "2px solid lightgray",
    width: "34%",
  },
}));

const DividerWithText = ({ children }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.border} />
      <Content>{children}</Content>
      <div className={classes.border} />
    </div>
  );
};
export default DividerWithText;
